import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/**
 * Normalizes a given date to UTC with time set to 00:00:00.000.
 *
 * @param date - The date to normalize. Can be a `Date`, Mantine date string, or `null`.
 * @returns A new `Date` object normalized to UTC, or `null` if the input is `null`.
 */
export const normalizeDate = (date: Date | string | null): Date | null => {
  if (!date) return null;
  const parsed = dayjs(date);
  if (!parsed.isValid()) return null;
  return new Date(
    Date.UTC(parsed.year(), parsed.month(), parsed.date(), 0, 0, 0, 0),
  );
};

// Rounds to the nearest UTC midnight: older reports stored local midnight (e.g. 23:00Z for the next day).
export const toUtcCalendarDay = (value: string) =>
  dayjs.utc(value).add(12, "hour").format("YYYY-MM-DD");
